import { cva, VariantProps } from "class-variance-authority";
import { cn } from "@/utils/classes";
import { PadlockIcon } from "@/assets/icons";
import { MemoryEmotionIndicator } from "@/components/ui/indicator";
import { EmotionScore } from "@/api/studio/insights/types/emotion.type";

/* Variants */
const variants = cva("grid grid-cols-2 justify-between text-base items-center gap-2", {
  variants: {
    size: {
      small: "text-xs",
      medium: "text-base",
      large: "text-lg font-medium",
      xlarge: "text-xl font-medium",
    },
  },
  defaultVariants: {
    size: "medium",
  },
});

/* Prop Types */
interface MemoryEmotionMetricProps extends VariantProps<typeof variants> {
  title?: string;
  value?: number;

  className?: string;
  truncate?: boolean;
  locked?: boolean;
  icon?: React.ReactNode;
  type: "emotion" | "memory" | "reaction";
  textSize?: "xs" | "sm" | "base" | "lg";
}

/*
 * MemoryEmotionMetric Component
 *
 * Displays a memory or emotion metric with an optional icon and lock indicator.
 */
export const MemoryEmotionMetric = ({ title, value, className, size, truncate, icon, locked, type, textSize }: MemoryEmotionMetricProps) => {
  return (
    <div className={cn(variants({ size }), className)}>
      <div className="flex flex-row items-center gap-2">
        {icon}
        {title && <span className={cn({ truncate: truncate })}>{title}</span>}
      </div>
      <div className="flex flex-row items-center gap-2">
        {locked ? <PadlockIcon isGradient={true} /> : <MemoryEmotionIndicator score={value as EmotionScore} size="small" textSize={textSize} type={type} />}
      </div>
    </div>
  );
};
